var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.prize)?_c('div',[_c('h6',[_vm._v("Multiplier")]),_c('multiplier',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.model.prize.multiplier),callback:function ($$v) {_vm.$set(_vm.model.prize, "multiplier", $$v)},expression:"model.prize.multiplier"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }